import type { CustomerInfo } from "@lana-commerce/core/modules/customer";
import { createEvent, createStore } from "effector";

import type { ProductBrief } from "../data/def";

const CURRENCY_KEY = "clay_currency";

let initialCurrency = "";
try {
  initialCurrency = localStorage.getItem(CURRENCY_KEY) || "";
} catch {
  // do nothing
}

export const setCartCount = createEvent<number>();
export const $cartCount = createStore(0).on(setCartCount, (_, v) => v);

export const setCurrency = createEvent<string>();
export const $currency = createStore(initialCurrency).on(setCurrency, (_, v) => v);

export const setCustomerInfo = createEvent<CustomerInfo | null>();
export const $customerInfo = createStore<CustomerInfo | null>(null).on(setCustomerInfo, (_, v) => v);

export const setJWT = createEvent<string>();
export const $jwt = createStore<string>("").on(setJWT, (_, v) => v);

export const setRecentlyVisitedProducts = createEvent<ProductBrief[]>();
export const $recentlyVisitedProducts = createStore<ProductBrief[]>([]);

$currency.watch((v) => {
  try {
    localStorage.setItem(CURRENCY_KEY, v);
  } catch {}
});
